import React from "react";

const columns = ({  } = {}) =>
  [
    {
      // key: "Id",
      title: "#",
      dataIndex: "stt",
      width: "65px"
    },
    {
      // key: "",
      title: "Tên hạng mục",
      dataIndex: "ten",
      render: value => <span className="row-name">{value}</span>
    },
  ].map(col => ({...col}));

export default columns;
